import React, { useState, useEffect, useRef } from 'react';

const MAX_RETRIES = 6;

// Renders an <img> that automatically retries loading on error (e.g. backend cold-start
// after the production server was asleep) before falling back to a placeholder.
const ImageWithRetry = ({ src, alt, className, fallbackText = 'Product', fallbackSize = '400x400', ...rest }) => {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [failed, setFailed] = useState(false);
  const retriesRef = useRef(0);
  const timerRef = useRef(null);

  useEffect(() => {
    setCurrentSrc(src);
    setFailed(false);
    retriesRef.current = 0;
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [src]);

  const handleError = () => {
    if (!src) { setFailed(true); return; }
    if (retriesRef.current >= MAX_RETRIES) {
      setFailed(true);
      return;
    }
    retriesRef.current += 1;
    const delay = Math.min(1000 * retriesRef.current, 5000);
    timerRef.current = setTimeout(() => {
      const sep = src.includes('?') ? '&' : '?';
      setCurrentSrc(`${src}${sep}r=${retriesRef.current}_${Date.now()}`);
    }, delay);
  };

  if (failed || !src) {
    return (
      <img
        src={`https://placehold.co/${fallbackSize}/1a1a1a/666666?text=${encodeURIComponent(fallbackText)}`}
        alt={alt}
        className={className}
        {...rest}
      />
    );
  }

  return <img src={currentSrc} alt={alt} className={className} onError={handleError} {...rest} />;
};

export default ImageWithRetry;
